import useMember from '@src/Store/selectors/useMember';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLazyGetUserSubscriptionQuery} from '~Api/TraceApi/traceApi';
import memberSlice, {IMemberSubscription} from '~Store/Slices/Member.slice';
import {isMtnTestMember} from '@src/Hooks/useMtnLoginCompletion';

export const CARRIER_TO_DISPLAY_PLAN: Record<string, string> = {
  'trace.vodacom.subscription': 'trace.monthly.subscription',
  'trace.mtn.subscription': 'trace.monthly.subscription',
};

export const CARRIER_FROM_EXTERNAL_ID: Record<string, string> = {
  'trace.vodacom.subscription': 'vodacom',
  'trace.mtn.subscription': 'mtn',
};

export const useMemberSubscription = () => {
  const member = useMember();
  const dispatch = useDispatch();
  const [getUserSubscription] = useLazyGetUserSubscriptionQuery();

  useEffect(() => {
    // MTN test login (backend MTN_DB_DISABLED): subscription comes from Penrose, not the DB
    if (member && isMtnTestMember(member._id)) return;
    if (member) {
      getUserSubscription()
        .then(({data}) => {
          if (data) {
            const rawProductId = data.externalID;
            let memberSubscription: IMemberSubscription = {
              memberId: data.memberId,
              subscriptionStart: data.subscriptionStart.toString(),
              subscriptionEnd: data.subscriptionEnd?.toString(),
              id: data._id,
              deviceType: data.deviceType,
              subscriptionType: data.subscriptionTypeId,
              productId:
                CARRIER_TO_DISPLAY_PLAN[rawProductId] || rawProductId,
              cancelRequested: data.cancelRequested,
              carrier: CARRIER_FROM_EXTERNAL_ID[rawProductId],
            };
            dispatch(
              memberSlice.actions.setMemberSubscription(memberSubscription),
            );
            // checkReceipt(memberSubscription);
          } else {
            dispatch(memberSlice.actions.setMemberSubscription(undefined));
          }
        })
        .catch(error => {
          console.log('error get subscription', JSON.stringify(error));
          dispatch(memberSlice.actions.setMemberSubscription(undefined));
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member]);
};
